export const UserRoles = ['CUSTOMER', 'PROVIDER', 'ADMIN'];

export const UserRoleOptions = [
  { label: 'Customer', value: 'CUSTOMER' },
  { label: 'Provider', value: 'PROVIDER' },
  { label: 'Admin', value: 'ADMIN' },
];

// TODO: Should be moved to API side
export const UserDefaultLabels = [
  'NFR',
  'LOCKED',
  'VSTBuzz',
  'Pluginboutique',
  'Time & Space',
  'Best Service',
  'Sweetwater',
  'Crypton',
  'Audiodeluxe',
  'Kvr',
  'Jrr',
  'Reverb',
];
